import $ from "jquery";
import setAppLinksParams from "scripts/components/setAppLinksParams";
import { GAPageView } from "scripts/components/ga/page_view";
import header from "../components/header";
import Select from "../components/select";
import wishlist from "../components/wishlist/wishlist";
import inputSearch from "../components/inputSearch";
import response from "../components/response";
import catalogue from "../components/catalogue";
import forms from "../components/forms";
import modals from "../components/listing/modals";
import { initMinicardEvents } from "../components/minicard";
import { initLoadHits } from "../components/hits-slider";
import { GASelectItem } from "../components/ga/select_item";
import { categorySlider } from "../components/sliders";
import tooltip from "../components/tooltip";
import { initSupport } from "scripts/components/support/support";
import {initLazyLoadingRecaptcha} from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  GAPageView();
  header();
  inputSearch();
  response();
  catalogue();
  forms();
  modals();
  wishlist();
  initMinicardEvents();
  initLoadHits();
  GASelectItem();
  categorySlider();
  tooltip();
  initSupport();
  initLazyLoadingRecaptcha();

  window.sortSelect = new Select({
    selector: ".js_listing_sort_select",
    customSelectClassName: "listing-sort-select",
  });

  window.customSelect = new Select({
    selector: "select:not(.js_listing_sort_select)",
  });

  setAppLinksParams();

  if ($(".block-seo").length) {
    const seoContentHeight = $(".js_seo_content").height();
    if (seoContentHeight < 170) {
      $(".js_seo_container").css("max-height", "none");
      $(".js_seo_toggles").hide();
      return;
    }
    const wrapper = $(".block-seo .wrapper:not(.opener-holder)");
    const height = wrapper.height();
    const realHeight = wrapper.prop("scrollHeight");

    if (realHeight < height) {
      $(".block-seo .opener-holder").remove();
    }
  }
  $(".block-seo__opener").on("click", function showSeoText() {
    $(this).parents(".block-seo").toggleClass("active");
  });
});
